/** Reads `trace-id` from each item returned by ads-tracer GET /v1/traces/{testCaseId}. */
export function extractZipkinTraceIdFromTraceApi(trace) {
  if (!trace || typeof trace !== 'object') {
    return null;
  }
  const raw = trace['trace-id'];
  if (raw == null || raw === '') {
    return null;
  }
  const s = String(raw).trim();
  return s || null;
}

export function buildZipkinTraceUrl(template, traceId) {
  if (!template || !traceId) {
    return null;
  }
  return template.split('{traceId}').join(traceId);
}
